import React from 'react';
import Layout from "./Components/Layout";
import Footer from "./Components/Footer";
import Container from "./Components/Container";

import './App.css';

import './Fonts/Inter-Black.ttf';
import './Fonts/Montserrat-Regular.otf';

function App() {

  return (
      <Layout footer ={<Footer/>}>
          <Container/>
      </Layout>
  );
}

export default App;